/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainer_similarLandingItems = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_similarLandingItems",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems",
      "args": null
    }
  ],
  "type": "moreLikeThisConnection"
};

module.exports = fragment;
